export const MAIN_MAP = 'mainMap';
export const SITE_CARD_MAP = 'siteCardMap';
export const PLANNING_ALERT_MAP = 'planningAlertMap';
export const PRINT_MAP = 'printMap';